import RichText from "@/components/RichText";
import { CONTAINER } from "../tokens";

// Avis clients : citation en haut, bloc auteur poussé en bas de carte. Un
// avatar sans image garde le motif hachuré du handoff, comme les logos
// clients.
const HATCH = {
  backgroundImage:
    "repeating-linear-gradient(135deg, rgb(var(--c-ink, 22 21 15) / 0.13) 0 2px, transparent 2px 9px)",
};

export default function TestimonialsSection({ props = {}, blocks = [] }) {
  const items = (blocks || []).filter((b) => b.type === "testimonial" && b.enabled !== false);

  return (
    <section id="avis" className={`${CONTAINER} pt-[92px] scroll-mt-24`}>
      <RichText
        as="h2"
        className="block font-display font-semibold text-[clamp(29px,3.5vw,43px)] leading-[1.06] tracking-[-0.03em] mb-10 max-w-[520px] text-ink [text-wrap:pretty]"
        html={props.heading}
      />
      <div className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(280px,1fr))]">
        {items.map((b) => (
          <div
            key={b.id}
            data-block-key={b.id}
            className="border-control border-ink/[0.12] rounded-card p-7 bg-ink/[0.025] flex flex-col gap-[22px]"
          >
            <p className="text-[16.5px] leading-[1.6] text-ink/[0.86] [text-wrap:pretty]">
              «&nbsp;{b.props?.quote}&nbsp;»
            </p>
            <div className="flex items-center gap-3 mt-auto">
              {b.props?.image_url ? (
                <img
                  src={b.props.image_url}
                  alt=""
                  className="h-[38px] w-[38px] rounded-full object-cover shrink-0"
                />
              ) : (
                <div className="h-[38px] w-[38px] rounded-full shrink-0" style={HATCH} />
              )}
              <div>
                <div className="font-display text-[14.5px] font-medium text-ink">{b.props?.author}</div>
                <div className="text-[13px] text-ink/[0.5]">{b.props?.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
